import  { useState, useEffect } from 'react';
import { Chart, LineElement, BarElement, CategoryScale, LinearScale, PointElement, BarController, LineController } from 'chart.js';
import { Chart as ChartJS } from 'react-chartjs-2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import config from "../config.js"

Chart.register(LineElement, BarElement, CategoryScale, LinearScale, PointElement, BarController, LineController);

const EmailMarketingCampaign = () => {
  const [GoogleData, setGoogleData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { API_BASE_URL } = config;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/v1/MarketingworkbookToJson`);
        setGoogleData(response.data.data.Google);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error);
        setLoading(false);
      }
    };

    fetchData();
  }, [API_BASE_URL]);

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Typography variant="h6" color="error">Error fetching data</Typography>;
  }

  const dates = GoogleData.map(entry => entry.DATE);
  const directData = GoogleData.map(entry => entry.DIRECT);
  const organicData = GoogleData.map(entry => entry.ORGANIC);
  const referralData = GoogleData.map(entry => entry.REFERRAL);
  const paidData = GoogleData.map(entry => entry.PAID);
  const otherData = GoogleData.map(entry => entry.OTHER);

  const chartData = {
    labels: dates,
    datasets: [
      {
        type: 'bar',
        label: 'Direct',
        data: directData,
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        borderColor: 'rgba(255, 99, 132, 1)',
        borderWidth: 1,
      },
      {
        type: 'line',
        label: 'Organic',
        data: organicData,
        borderColor: 'rgba(54, 162, 235, 1)',
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        fill: false,
      },
      {
        type: 'line',
        label: 'Referral',
        data: referralData,
        borderColor: 'rgba(255, 206, 86, 1)',
        backgroundColor: 'rgba(255, 206, 86, 0.2)',
        fill: false,
      },
      {
        type: 'bar',
        label: 'Paid',
        data: paidData,
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      },
      {
        type: 'bar',
        label: 'Other',
        data: otherData,
        backgroundColor: 'rgba(153, 102, 255, 0.2)',
        borderColor: 'rgba(153, 102, 255, 1)',
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: true,
      },
    },
    scales: {
      x: {
        display: true,
        title: {
          display: true,
          text: 'Date',
        },
      },
      y: {
        display: true,
        title: {
          display: true,
          text: 'Subscribers',
        },
      },
    },
  };

  return (
    <Box>
      
      <Box>
        <List sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <ListItem sx={{ color: 'textSecondary' }}>Direct</ListItem>
          <ListItem sx={{ color: 'textSecondary' }}>Organic</ListItem>
          <ListItem sx={{ color: 'textSecondary' }}>Referral</ListItem>
          <ListItem sx={{ color: 'textSecondary' }}>Paid</ListItem>
          <ListItem sx={{ color: 'textSecondary' }}>Other</ListItem>
        </List>
      </Box>
      <Box>
        <ChartJS type="bar" data={chartData} options={options} />
      </Box>
    </Box>
  );
};

export default EmailMarketingCampaign;

